const KEY = 'shared-device';
const SHARED = 'yes';

export const getSharedDevice = (): boolean =>
  window.localStorage.getItem(KEY) === SHARED;
export const setSharedDevice = (value: boolean): void => {
  if (value) {
    window.localStorage.setItem(KEY, SHARED);
  } else {
    window.localStorage.removeItem(KEY);
  }
};
